import {Component} from '@angular/core';

@Component({
  selector: 'vui-inputs',
  templateUrl: './inputs.component.html',
  styleUrls: ['./inputs.component.scss']
})
export class InputsComponent {

}
